import React from 'react';
import Phone from '@kyruus/react-ikons/Phone';
import { SvgLink } from './styles';
import { getPhone } from './utils';
import { arrayOf, object } from 'prop-types';

function MobilePhone({ contacts }) {
  const phoneNumber = getPhone(contacts);
  const phoneLink = `tel:${phoneNumber}`;

  return (
    <SvgLink href={phoneLink} aria-label={phoneNumber}>
      <Phone size="23px" />
    </SvgLink>
  );
}

MobilePhone.propTypes = {
  contacts: arrayOf(object).isRequired
};

export default MobilePhone;
